var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: { active: _vm.active, "has-modal-card": "" },
      on: { close: _vm.close },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title is-flex-items-center" }, [
          _c("span", [_vm._v("New Company")]),
        ]),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "buttons is-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary is-medium",
              on: {
                click: function ($event) {
                  return _vm.create("hq")
                },
              },
            },
            [
              _c("span", { staticClass: "icon is-small" }, [
                _c("span", { staticClass: "mso mso-24px" }, [
                  _vm._v("apartment"),
                ]),
              ]),
              _c("span", [_vm._v("Create HQ Company")]),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "button is-primary is-medium",
              on: {
                click: function ($event) {
                  return _vm.create("normal")
                },
              },
            },
            [
              _c("span", { staticClass: "icon is-small" }, [
                _c("span", { staticClass: "mso mso-24px" }, [_vm._v("domain")]),
              ]),
              _c("span", [_vm._v("Create Normal/Branch Company")]),
            ]
          ),
        ]),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Close" },
                on: { click: _vm.close },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("span", { staticClass: "mso mso-20px" }, [
                    _vm._v("close"),
                  ]),
                ]),
                _c("span", [_vm._v("Close")]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }